import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { reloadForNewVersion } from '@/lib/app-reload'

// Chặn SỚM lỗi tải chunk sau deploy: Vite phát 'vite:preloadError' khi preload
// module động thất bại (hash file cũ đã bị xoá) → tự tải lại lấy bản mới, không để
// lỗi nổi thành màn hình lỗi. Guard chống lặp nằm trong reloadForNewVersion.
// (RootErrorBoundary ở router là lớp bắt dự phòng cho các lỗi lọt qua đây.)
window.addEventListener('vite:preloadError', () => {
  reloadForNewVersion()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
